import React from 'react';
import Card from '../../components/Card';
import CardHeader from '../../components/CardHeader';
import ServiceList from '../../components/ServiceList';
import { I18n } from 'react-redux-i18n';

const ServiceNotification = ({
  data,
  services_info,
  onChangeSelect,
  onChangeCheckbox
}) => {
  const options = {
    newsletter: [
      { value: true, label: I18n.t('admin.services.yes') },
      { value: false, label: I18n.t('admin.services.no') }
    ],
    reception: []
  };
  for (let index = 6; index <= 12; index++) {
    options.reception.push({ value: index, label: `${index}h` });
  }
  let notifications = services_info ? services_info : [];
  notifications = notifications.filter((item) => item.is_subscribable);
  const newsletter = options.newsletter.find(
    (item) => item.value === data.newsletter
  );
  const newsletterHour = options.reception.find(
    (item) => item.value === data.newsletterHour
  );
  return (
    <Card className="adminCard">
      <CardHeader
        textTransform="normal"
        title={I18n.t('admin.services.title')}
        icon="notification"
        iconPosition="left"
        iconContainer
      />
      <div className="adminCardContent">
        <ServiceList
          options={options}
          newsletter={newsletter}
          newsletterHour={newsletterHour}
          onChangeSelect={(field, value) => onChangeSelect(field, value)}
          onChangeCheckbox={(index) => onChangeCheckbox(index)}
          notifications={notifications}
        />
      </div>
    </Card>
  );
};

export default ServiceNotification;
